<template>
  <el-form :label-position="'top'" :model="registerForm" :rules="registerRules" ref="registerForm" label-width="80px"  >
    <el-row :gutter='0' style="text-align: center">
      <el-col><h2>美钥二维码注册</h2></el-col>
    </el-row>
    <el-form-item label="邮箱" prop="email">
      <el-input v-model="registerForm.email" placeholder="Email"></el-input>
    </el-form-item>

    <el-form-item label="密码" prop="password">
      <el-input v-model="registerForm.password" type="password" placeholder="Password"></el-input>
    </el-form-item>

    <el-form-item label="密码确认" prop="confirm_password">
      <el-input v-model="registerForm.confirm_password" type="password" placeholder="Password"></el-input>
    </el-form-item>

    <el-form-item prop="agree">
      <el-checkbox v-model="registerForm.agree">我已阅读并同意遵守</el-checkbox>
      <a href="/terms" target="_blank">服务条款</a>
    </el-form-item>

    <el-form-item>
        <el-button class="formBtn" type="primary" @click="submitForm('registerForm')">注册</el-button>  
    </el-form-item>
    <el-form-item>
        <div class="line-dashed"></div>
        <p class="text-muted"><small>已有账户?</small></p>
        <el-button class="formBtn" @click="routeToLogin">马上登录</el-button>  
    </el-form-item>
  </el-form>
</template>

<script type="text/javascript">
import $ from 'jquery'
export default {
  name: 'registerForm',
  data () {
    // 校验用户输入的两次密码相同
    let validatePassEq = (rule, value, callback) => {
      if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    // 校验用户勾选了服务条款
    let validateIsTrue = (rule, value, callback) => {
      if (value !== true) {
        callback(new Error('必须同意服务条款才能使用该产品'))
      } else {
        callback()
      }
    }
    return {
      registerForm: {
        email: '',
        password: '',
        confirm_password: '',
        agree: true
      },
      registerRules: {
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', required: true, message: '请输入可用的邮件地址', trigger: 'blur' },
          { max: 50, message: '您的用户名至多包含50个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '您的密码需要至少包含6个字符', trigger: 'blur' },
          { max: 40, message: '您的密码至多包含40个字符', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '您的密码需要至少包含6个字符', trigger: 'blur' },
          { max: 40, message: '您的密码至多包含40个字符', trigger: 'blur' },
          { validator: validatePassEq, trigger: 'blur' }
        ],
        agree: [
          { validator: validateIsTrue, trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    submitForm (formName) {
      const vm = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          $.ajax({
            type: 'POST',
            url: '/v1/user/register/process',
            dataType: 'json',
            async: true,
            data: {
              email: vm.registerForm.email,
              password: vm.registerForm.password
            },
            success: function (data) {
              if (data.code === 200) {
                vm.$router.push('/user/register/resendPrompt?email=' + vm.registerForm.email)
              } else if (data.code === 409) {
                vm.$message.error('该账户已经存在，请直接登录')
              } else if (data.code === 503) {
                vm.$message.warning('该角色尚未启用，如有需要，请联系管理人员')
              } else if (data.code === 400) {
                vm.$message.error('该角色不存在')
              } else {
                vm.$message.error('系统异常，请稍后重试')
              }
            },
            error: function (XMLHttpRequest, textStatus, errorThrown) {
              if (textStatus === 'timeout') {
                vm.$message.error('响应超时，请稍后重试')
              } else if (errorThrown === 'Unauthorized') {
                vm.$message.error('未授权')
              } else {
                vm.$message.error('系统异常，请稍后重试')
              }
            }
          })
        } else {
          return false
        }
      })
    },
    routeToLogin () {
      this.$router.push('/user/login')
    }
  }
}
</script>

<style type="text/css" scoped>
.formBtn {
  width: 100%;
}
.line-dashed{
  *width: 100%;
  height: 2px;
  font-size:0;
  overflow: hidden;
  background-color: #fff;
  border-width:0;
  border-top: 1px solid #e0e4e8;
  border-style: dashed;
  background: transparent;
}
.text-muted{
  color: #919599;
  margin: 0;
  text-align: center;
}
</style>
